import React from "react";
import PageContainer from "../../../components/PageContainer/PageContainer";
import { Button, colors } from "@repo/ui";
import { useMediaQuery } from "react-responsive";
import EventDetails from "../components/AsideSection/EventDetails";
import undoIcon from "../../../assets/icons/undo.svg";
import { useNavigate, useParams } from "react-router-dom";
import TabNavigation from "../../../components/TabNavigation/TabNavigation";
import CartContent from "../components/CartContent";
import BackButton from "../../../components/BackButton";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";
import TwoColumnLayout from "../../../components/TwoColumnLayout/TwoColumnLayout";

const LOCALE = "modules_Guests_pages_CartPage";

const CartPageWeb: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  return (
    <PageContainer startColor={colors.background} endColor="white">
      <div className="p-0 md:p-8 w-[100vw]">
        <TwoColumnLayout
          aside={
            <>
              <EventDetails />
              <Button
                className="w-full"
                label={
                  <div className="flex items-center justify-between">
                    <span>{t("goBack")}</span>
                    <img
                      src={undoIcon}
                      alt="Go back"
                      className="ml-2 h-4 w-4"
                    />
                  </div>
                }
                type="secondary"
                onClick={() => navigate(`/guests/gifttable/${id}`)}
              />
            </>
          }
          asideWidth="clamp(300px, 15vw, 10%)"
          stickyTop="0px"
          paddingClass="p-4"
          asideClassName="space-y-8 text-white"
          mainClassName="flex-1"
        >
          <TabNavigation
            tabs={[{ label: t("shoppingCart"), component: <CartContent /> }]}
          />
        </TwoColumnLayout>
      </div>
    </PageContainer>
  );
};

const CartPageMobile: React.FC = () => {
  const { t } = useTranslation(LOCALE);

  return (
    <PageContainer startColor={colors.background} endColor="white">
      <div className="flex flex-col p-0 w-screen">
        {/* Back arrow */}
        <div className="flex items-center p-4">
          <BackButton text={t("return")} />
        </div>
        <main className="flex-1 w-screen">
          <TabNavigation
            tabs={[{ label: t("shoppingCart"), component: <CartContent /> }]}
          />
        </main>
      </div>
    </PageContainer>
  );
};

const CartPage: React.FC = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return isMobile ? <CartPageMobile /> : <CartPageWeb />;
};

export default withTranslations(LOCALE)(CartPage);
